import { getContrastingTextColor } from "../../util/ColorUtil";
import { truncateName } from "../../util/stringUtils";

const BLOCKED_COLOR = "#dc2626";

const Tag = ({ tag, handleTagRemove }) => {
  const resolvedTagId =
    tag?.tag_id ?? tag?.id ?? tag?.tag?.tag_id ?? tag?.tag?.id;
  const isBlocked = tag?.name && tag.name.toLowerCase() === "blocked";
  const isBlocking = tag?.name && tag.name.toLowerCase() === "blocking";

  const className = [
    "tag",
    isBlocked ? "tag-blocked" : "",
    isBlocking ? "tag-blocking" : "",
  ]
    .filter(Boolean)
    .join(" ");

  const backgroundColor = isBlocked || isBlocking ? BLOCKED_COLOR : tag.color;
  const color = backgroundColor
    ? getContrastingTextColor(backgroundColor)
    : undefined;

  return (
    <div
      className={className}
      key={resolvedTagId ?? tag?.name}
      style={{
        backgroundColor,
        color,
      }}
    >
      <span className="tag-content">{truncateName(tag.name)}</span>
      {handleTagRemove && (
        <>
          <span
            className="tag-delete-icon"
            onClick={(e) => {
              e.stopPropagation();
              handleTagRemove(resolvedTagId, tag);
            }}
          >
            &times;
          </span>
        </>
      )}
    </div>
  );
};

export default Tag;
